module.exports = __webpack_public_path__ + "img/teacher4.191c0410.png";